import SuccessScreen from './SuccessScreen';

export default SuccessScreen;
